module.exports = __webpack_public_path__ + "static/img/27.6e4ff04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/27.jpg
// module id = HYVM
// module chunks = 1